// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__JFued","searchIcon":"SearchBar_searchIcon__z0HZu","searchInput":"SearchBar_searchInput__mfltW"};